// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
// Note: this is preferred over using `LinkInitOptions.deviceMetadata` since
// that doesn't have a consistent spec across SDKs.
import { DeviceType } from '../types/device-types';
export var isDeviceIOS = function () {
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
};
export var isDeviceAndroid = function () {
    return /Android/i.test(navigator.userAgent);
};
export var getDeviceType = function () {
    if (isDeviceIOS())
        return DeviceType.IOS;
    if (isDeviceAndroid())
        return DeviceType.ANDROID;
    return DeviceType.WEB;
};
